import { Box, styled } from "@mui/material";
import CaltexLubewatch from "../../assets/images/logos/caltex-lubewatch-logo.png";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const CaltexLogo = styled("img")({
    height: "60px",
});

const Layout = (props) => {
    const location = useLocation();
    const [renderHeader, setRenderHeader] = useState(true);

    useEffect(() => {
        if (location.pathname.includes("-pdf") || location.pathname === "/") {
            setRenderHeader(false)
        } else {
            setRenderHeader(true)
        }
    }, [location.pathname]);

    return (
        <Box>
            {renderHeader && (
                <Box component="header" sx={{ padding: "1rem", height: "80px", display: "flex", alignItems: "center" }}>
                    <CaltexLogo src={CaltexLubewatch} alt="Caltex Lubewatch" />
                </Box>
            )}

            <Box component="main">{props.children}</Box>
        </Box>
    );
};

export default Layout;
